import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heat-meter-container"},[_c('div',{staticClass:"metric-pointer",style:(("margin-left: " + (_vm.getLeadingOffset()) + "%;"))},[_c(VIcon,{attrs:{"size":"60px","color":"black"}},[_vm._v("mdi-chevron-down")])],1),_c('div',{staticClass:"metric"})])}
var staticRenderFns = []

export { render, staticRenderFns }